import React, { useState, useEffect } from "react";
import Recepients from "./Recepients";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import EscrowContractAbi from "../Services/EscrowContractAbi.json";
import { ethers } from "ethers";
import newContractAbi from "../Services/NewContractAbi.json";
import { Spinner } from "flowbite-react";
import { EthContracatAddress } from "../Services/EthContractAddress";
import EthContractAbi from "../Services/EthContracatAbi.json";
import { useSigner, useAccount, useNetwork } from "wagmi";
const { BigNumber } = require("ethers");

const RecipientAccount = () => {
  //----------------------useHook from wagmi-------------------------------------//
  const { chain } = useNetwork();
  const { data: signer } = useSigner();
  const { address } = useAccount();
  //------------------------STATES------------------------------------//

  const [data, setData] = useState([]);
  const [waiting, setWaiting] = useState(true);

  //--------------------USEEFFECT---------------------------//
  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("chainChanged", () => {
        if (signer) {
          getAllContracts(chain.id);
        }
      });
      window.ethereum.on("accountsChanged", () => {
        if (signer) {
          getAllContracts(chain.id);
        }
      });
    }
    
    if (signer) {
      getAllContracts(chain.id);
    }
  }, [signer, chain]);

  //----------------------All TX Status ---------------------------------------------------//

  const getAllContracts = async (id) => {
    if (id === 11155111) {
     
      try {
        setData("");
        setWaiting(true);

        let Contract;
        if (signer) {
          Contract = new ethers.Contract(
            EthContracatAddress,
            EthContractAbi,
            signer
          );
        }

        const response = await Contract?.getUsercontracts(address);

        const contractPromises = response.map(async (val) => {
          const newContract = new ethers.Contract(val, newContractAbi, signer);
          return newContract.smartContract().then(async (response) => {
            await new Promise((r) => setTimeout(r, 100));

            let status;
            if (response.cancelled === true) {
              status = "Cancelled";
            } else if (response.executed === true) {
              status = "Executed";
            } else {
              status = "Cancel";
            }

            const wei = BigNumber.from(response.amount).toString();
            const ether = ethers.utils.formatEther(wei);
            return {
              address: val,
              Recipient: response.recipient,
              isActive: status,
              Amount: ether,
              UnLockTime: BigNumber.from(response.unlockTime).toString(),
            };
          });
        });
        const contracts = await Promise.all(contractPromises);

        setData(contracts);

        setWaiting(false);
      } catch (error) {
        console.log(error);
      }
    } else {
     

      try {
        setData("");
        setWaiting(true);

        let Contract;
        if (signer) {
          Contract = new ethers.Contract(
            EscrowContractAddress,
            EscrowContractAbi,
            signer
          );
        }

        const useraddress = signer.getAddress();

        const response = await Contract?.getUsercontracts(useraddress);

        const contractPromises = response.map((val) => {
          const newContract = new ethers.Contract(val, newContractAbi, signer);
          return newContract.smartContract().then((response) => {
            let status;
            if (response.cancelled === true) {
              status = "Cancelled";
            } else if (response.executed === true) {
              status = "Executed";
            } else {
              status = "Cancel";
            }
            const wei = BigNumber.from(response.amount).toString();
            const ether = ethers.utils.formatEther(wei);
            return {
              address: val,
              Recipient: response.recipient,
              isActive: status,
              Amount: ether,
              UnLockTime: BigNumber.from(response.unlockTime).toString(),
            };
          });
        });
        const contracts = await Promise.all(contractPromises);
        
        
        setData(contracts);
       
        setWaiting(false);
       
      } catch (error) {
        console.log(error);
      }
    }
  };



  return (
    <div>
      <div className="p-8">
        <div className="    pt-10  ">
          <div className="md:flex md:gap-96 justify-between">
            <h1 className=" py-2 text-blue-400 pl-4">My Recepient</h1>
          </div>
          <div className="">
            <div className=" grid grid-cols-4 gap-28 items-center px-4  ">
              <h1> Address</h1>
              <h1 className=""> Amount</h1>
              <h1 className="-ml-6"> SentDate</h1>
            </div>

            {waiting ? (
              <div className=" p-8">
                <Spinner />
              </div>
            ) : (
              
              data &&
              data?.reverse()?.map((val) => {
                return (
                  <Recepients
                    ContractAddress={val.address}
                    Recipient={val.Recipient}
                    status={val.isActive}
                    ContractAmount={val.Amount}
                    unlocktime={val.UnLockTime}
                  />
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipientAccount;
